'use strict';
import classNames from 'classnames';
import get from 'lodash/get';
import isNumber from 'lodash/isNumber';
import * as T from 'prop-types';
import React, {Component, Fragment} from 'react';
import {ValidationErrorMessages} from '../../../../../components/forms/ValidationErrorMessages';


export class TextLongFieldEditView extends Component {
  static propTypes = {
    field: T.object.isRequired,
    isSaving: T.bool.isRequired,
    onChange: T.func.isRequired,
    validationMessages: T.arrayOf(T.string),
  };

  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(ev) {
    const {
      field,
      onChange,
    } = this.props;

    onChange([field.id, {
      target: {
        value: ev.target.value,
      },
    }]);
  }

  render() {
    const props = this.props;
    const {options} = props.field;

    return (
      <Fragment>
        <div className={classNames("TextLongFieldEdit", this.props.className)}>
          <textarea
            className={classNames("TextLongFieldEdit__input", {
              TextLongFieldEdit__input__saving: props.isSaving,
              TextLongFieldEdit__input__error: get(props.validationMessages, 'length'),
            })}
            disabled={props.isSaving}
            minLength={useNumber(options.minLength) ? options.minLength : void 0}
            maxLength={useNumber(options.maxLength) ? options.maxLength : void 0}
            rows="2"
            placeholder="Input here"
            value={props.value}
            onChange={this.handleChange}
          />
        </div>
        <ValidationErrorMessages validationMessages={props.validationMessages} />
      </Fragment>
    );
  }
}

function useNumber(param) {
  return isNumber(param) && param > 0;
}



// WEBPACK FOOTER //
// ./src/js/form-builder/components/response/fields/TextLongFieldEdit/TextLongFieldEditView.js